// extracted by mini-css-extract-plugin
module.exports = {"col-md-4":"ChatBanner_col-md-4__0rdU_","oChatBannerContainer":"ChatBanner_oChatBannerContainer__GrWFh","aChatBannerImage":"ChatBanner_aChatBannerImage__cYiAe"};